import objectPath from 'object-path'

export const updateSearchAPI = ({ action, designContext, buttonKey }) => {
  const { searchData, setSearchData, currentSearch, setCurrentSearch } =
    designContext
  let search = objectPath.get(action, 'search')
  setCurrentSearch({
    uiKey: buttonKey,
    search: search,
  })
  if (currentSearch?.uiKey) {
    objectPath.del(searchData, currentSearch.uiKey)
  }
  objectPath.set(searchData, buttonKey, true)
  setSearchData(searchData)
}

export const updateSearchField = ({ action, designContext }) => {
  const { searchData, setSearchData } = designContext
  let { searchField, searchValue } = action
  if (searchField) {
    objectPath.set(searchData, searchField, searchValue)
    setSearchData(searchData)
  }
}
